import { render, staticRenderFns } from "./hrleave.vue?vue&type=template&id=1396cad2&scoped=true&"
import script from "./hrleave.vue?vue&type=script&lang=js&"
export * from "./hrleave.vue?vue&type=script&lang=js&"
import style0 from "./hrleave.vue?vue&type=style&index=0&id=1396cad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396cad2",
  null
  
)

export default component.exports